function getMessage(field, args) {
  return `The ${field} is invalid.`
}

function validate(value, args) {
  if (value) {
    if (value.length !== 7) {
      return false
    } else {
      const regCheck = /^[A-Za-z0-9][0-9{5}][0-9\-]*$/
      return regCheck.test(value)
    }
  } else {
    return true
  }
}

export default {
  getMessage,
  validate
}
